import styled from 'styled-components';

// Components
import { Typography } from '../../display/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  border-radius: 0.5rem;
  padding: 0 1rem;
  width: 30rem;
`;

export const ContainerInput = styled.div`
  display: flex;
  justify-content: space-between;
  /* Centrado y no alineado abajo: con el icono genérico la fila era baja y
     no se notaba, pero desde que pinta la MINIATURA (4,8rem) el aspa quedaba
     descolgada hacia abajo — visible sobre todo en movil. */
  align-items: center;
  gap: ${({ theme }) => theme.spaces.s}rem;
  padding: 0.9rem 0;
  &:first-of-type {
    border-top: 1px solid transparent;
  }
  &:not(:first-of-type) {
    border-top: 1px solid ${({ theme }) => theme.colors.paleDarkGrey};
  }
`;

export const SmallContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  overflow: hidden;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    align-items: center;
  }
`;

export const Text = styled(Typography)`
  line-height: 1.2em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const ContainerFileIcon = styled.img``;

export const ContainerRemoveIcon = styled.img`
  height: 1.9rem;
  width: 1.4rem;
  cursor: pointer;
`;

/**
 * Miniatura de la foto aún sin subir. Cuadrada y recortada para que la fila
 * mantenga su altura sea cual sea la orientación del original.
 */
export const Thumbnail = styled.img`
  width: 4.8rem;
  height: 4.8rem;
  object-fit: cover;
  border-radius: 0.4rem;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.paleDarkGrey};
`;
